// extracted by mini-css-extract-plugin
export default {"heading":"help_heading__SrZrl","papercontainer":"help_papercontainer__Sq4pw","HelpSupportSec":"help_HelpSupportSec__MBLu0"};